import { useCallback, useEffect, useMemo, useRef } from 'react'

//TODO: найти более хорошее решение
export const useLoopCallback = (callback: (index: number) => ([...args]: any) => any, dependencies: any[]) => {
  const memoizedCallbacks = useRef<{ [index: string]: ([...args]: any) => any }>({})

  const memoizedCallback = useMemo(() => {
    memoizedCallbacks.current = {}
    return (index: number) => callback(index)
  }, dependencies)

  return useCallback(
    (index) => {
      if (!memoizedCallbacks.current[index]) {
        memoizedCallbacks.current[index] = memoizedCallback(index)
      }
      return memoizedCallbacks.current[index]
    },
    [memoizedCallback]
  )
}
